<template>
  <div class="animated fadeIn">
    <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
    <template v-else>
      <b-row v-if="IS_HAVE_PERMISSION_INPUT_KAS_VIRTUAL">
        <b-col sm="12" md="6" lg="4">
          <b-card body-class="p-4">
            <div class="d-flex justify-content-between gap-2">
              <div>
                <div class="d-flex align-items-center mb-2">
                  <i class="fa fa-credit-card-alt text-primary mr-2 font-xl"></i>
                  <span class="font-weight-bold text-primary font-md">Saldo Kas Induk</span>
                </div>
                <div class="cash-balance">
                  <StateDetailHandler :isLoading="stateKasInduk.isLoading" :isError="stateKasInduk.isError" :lines="1"
                    @retry="getKasInduk">
                    <span class="nominal font-bold font-lg">
                      Rp. {{ $helper.addThousandSeparator(stateKasInduk.data) }}
                    </span>
                  </StateDetailHandler>
                </div>
              </div>
              <div>
                <b-button class="icon-reload-btn" style="position: static;" :disabled="stateKasInduk.isLoading"
                  @click="getKasInduk"><i class="fa fa-refresh"></i></b-button>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>

      <b-card>
        <template v-slot:header>
          <h5>Kas Virtual</h5>
        </template>

        <b-row class="mb-3">
          <b-col cols="12" md="4">
            <b-form-group label="Cabang">
              <multiselect name="dariCabang" v-model="filters.cabang" :options="optionsCabang" :internal-search="true"
                :allow-empty="false" deselect-label="" select-label="" label="name" track-by="name"
                placeholder="Cabang" />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="12">
            <div class="d-flex justify-content-between align-items-center flex-wrap gap-2">
              <div class="d-flex flex-wrap gap-2">
                <b-button variant="pgiBtn" :disabled="isBusy" @click="onSearch()">
                  Search
                </b-button>
                <b-button variant="pgiBtn" :disabled="isBusy" @click="onReset()">Reset</b-button>
              </div>
              <div class="d-flex gap-2 flex-wrap" v-if="IS_HAVE_PERMISSION_INPUT_KAS_VIRTUAL">
                <b-button variant="pgiBtn" @click="onShowLogTransaksi">
                  Log Transaksi
                </b-button>
                <b-button variant="pgiBtn" @click="onShowModalInputKasVirtual">
                  Input Kas Virtual
                </b-button>
                <b-button variant="pgiBtn" @click="onShowModalBulkInputKasVirtual">
                  Bulk Input Kas Virtual
                </b-button>
                <b-button variant="pgiBtn" @click="onShowModalExportKasVirtual">
                  Export Kas Virtual
                </b-button>
              </div>
            </div>
          </b-col>
        </b-row>

        <div class="detail-data-wrapper">
          <b-table bordered hover show-empty :busy="isBusy" :items="data" :no-local-sorting="true" :fields="fields"
            @sort-changed="onSortChanged" responsive class="mb-3">
            <template v-slot:table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading data...</strong>
              </div>
            </template>
            <template v-slot:empty>
              Tidak ada data.
            </template>
            <template v-slot:cell(amount)="row">
              <p class="mb-0">Rp. {{ $helper.addThousandSeparator(row.item.currentVirtualBalance) }}</p>
            </template>
            <template v-slot:cell(status)="row">
              <span v-if="row.item.dokuStatus == IS_ACTIVE_KAS_VIRTUAL" class="status-box status-box-success" style="width: 80px;">Aktif</span>
              <span v-else class="status-box status-box-danger" style="width: 80px;">Tidak Aktif</span>
            </template>
            <template v-slot:cell(action)="row">
              <b-button size="sm" variant="pgiBtn" @click="onShowModalHistory(row.item)">
                Lihat Sejarah
              </b-button>
            </template>
          </b-table>

          <div class="pagination-wrapper d-flex align-items-center justify-content-between">
            <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
              <b-form-select v-model="show" @change="onLimitChange" :options="optionsLimit">
                <template v-slot:first>
                  <b-form-select-option :value="null" disabled />
                </template>
              </b-form-select>
              <span class="ml-2">{{ totalViewText }}</span>
            </b-input-group>
            <b-pagination class="mb-0" v-model="currentPage" :total-rows="totalRows" :per-page="perPage"
              aria-controls="my-table" @input="onPageChange"></b-pagination>
          </div>
        </div>
      </b-card>
    </template>

    <b-modal id="modal-log-transaksi" title="Log Transaksi" size="xl" hide-footer>
      <div class="d-flex flex-wrap gap-2 align-items-baseline mb-3">
        <b-form-group label="Tanggal" class="mb-0">
          <div class="d-flex" :class="isMobile ? 'flex-wrap' : ''">
            <b-form-input v-model="filters.startDate" name="filterFromDate" id="filterDate" type="date"
              class="flex-fill"></b-form-input>
            <span class="ml-2 mr-2 d-flex align-items-center">s/d</span>
            <b-form-input v-model="filters.endDate" name="filterToDate" type="date" class="flex-fill"
              :min="filters.startDate"></b-form-input>
          </div>
        </b-form-group>
        <b-button variant="pgiBtn" :disabled="isBusyLogTransaksi" @click="onSearchLogTransaksi()">
          Search
        </b-button>
        <b-button variant="pgiBtn" :disabled="isBusyLogTransaksi" @click="onResetLogTransaksi()">Reset</b-button>
      </div>
      <div class="detail-data-wrapper mb-0">
        <b-table bordered hover show-empty :busy="isBusyLogTransaksi" :items="dataLogTransaksi"
          :no-local-sorting="false" :fields="fieldsLogTransaksi" responsive class="mb-3">
          <template v-slot:table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading data...</strong>
            </div>
          </template>
          <template v-slot:empty>
            Tidak ada data.
          </template>
          <template v-slot:cell(amount)="row">
            <p class="mb-0">Rp. {{ $helper.addThousandSeparator(row.item.change) }}</p>
          </template>
          <template v-slot:cell(createdAt)="row">
            <p class="mb-0">{{ row.item.createdAt ? $helper.changeDateFormat(row.item.createdAt) : '' }}
              {{ row.item.createdAt ? $helper.changeDateFormatGetHour(row.item.createdAt) : '' }}</p>
          </template>
        </b-table>

        <div class="pagination-wrapper d-flex align-items-center justify-content-between">
          <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
            <b-form-select v-model="showLogTransaksi" @change="onLimitChangeLogTransaksi" :options="optionsLimit">
              <template v-slot:first>
                <b-form-select-option :value="null" disabled />
              </template>
            </b-form-select>
            <span class="ml-2">{{ totalViewTextLogTransaksi }}</span>
          </b-input-group>
          <b-pagination class="mb-0" v-model="currentPageLogTransaksi" :total-rows="totalRowsLogTransaksi"
            :per-page="perPageLogTransaksi" aria-controls="my-table" @input="onPageChangeLogTransaksi"></b-pagination>
        </div>
      </div>
    </b-modal>

    <ModalBulkInputKasVirtual @on-file-selected="handleBulkInputKasVirtual"
      :is-loading="isLoadingBulkInputKasVirtual" />

    <ModalHistoryKasVirtual :stateHistory="stateHistory" :pagination="stateHistory.pagination"
      :stateTotalBalanceCabang="stateTotalBalanceCabang" :cabang="selectedCabang" @retry="onRetryHistoryKas"
      @onLimitChange="onLimitChangeHistoryKas" @onPageChange="onPageChangeHistoryKas"
      modalId="modal-history-kas-virtual-action" />

    <ModalInputKasVirtual :optionsCabang="optionsCabang.filter((opt) => opt.id != null)"
      @onSuccessInputKasVirtual="onSuccessInputKasVirtual" />

    <ModalConfirm id="modal-export-kas-virtual" title="Konfirmasi Export Kas Virtual"
      :isSubmitting="isLoadingExportKasVirtual" desc="Apakah Anda yakin ingin export kas virtual?"
      @submit="handleExportKasVirtual" />

    <b-modal id="modal-download-kas-virtual" centered title="Download Kas Virtual" hide-footer no-close-on-backdrop>
      <div class="show-btn-download">
        <p class="">
          Silakan download dengan klik tombol dibawah ini :
        </p>
        <b-button variant="pgiBtn" class="mb-0 download-btn">
          <a v-bind:href="$baseFilePath + filePathDownload" download>
            <i class="fa fa-download mr-2"></i>
            Download Kas Virtual
          </a>
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import CONSTANTS from '@/constants'
import ModalInputKasVirtual from '@/components/modals/ModalInputKasVirtual'
import ModalHistoryKasVirtual from '@/components/modals/ModalHistoryKasVirtual'
import ModalBulkInputKasVirtual from '@/components/modals/ModalBulkInputKasVirtual'
import StateDetailHandler from '@/components/common/StateDetailHandler'

export default {
  name: 'kas-virtual',
  components: {
    ModalInputKasVirtual,
    ModalHistoryKasVirtual,
    ModalBulkInputKasVirtual,
    StateDetailHandler
  },
  data() {
    return {
      initStatus: 0,
      isBusy: true,
      data: [],
      isBusyLogTransaksi: true,
      dataLogTransaksi: [],
      filters: {
        cabang: null,
        startDate: null,
        endDate: null,
      },
      fields: [
        { key: "name", label: "Cabang" },
        { key: "amount", label: "Kas Virtual", sortable: true },
        { key: "status", label: "Status", thClass: 'text-center', tdClass: 'text-center' },
        { key: "action", label: "Aksi", thClass: 'text-center', tdClass: 'text-center' },
      ],
      fieldsLogTransaksi: [
        { key: "cabangName", label: "Cabang" },
        { key: "createdBy", label: "Dibuat oleh" },
        { key: "amount", label: "Nominal" },
        { key: "createdAt", label: "Tanggal" },
      ],
      currentPage: 1,
      show: 10,
      perPage: 10,
      totalRows: 0,
      totalPages: 0,
      totalViewText: "",
      currentPageLogTransaksi: 1,
      showLogTransaksi: 10,
      perPageLogTransaksi: 10,
      totalRowsLogTransaksi: 0,
      totalPagesLogTransaksi: 0,
      totalViewTextLogTransaksi: "",
      optionsLimit: CONSTANTS.OPTIONS_LIMIT_PAGINATION,
      optionsCabang: [],
      isMobile: false,
      stateKasInduk: {
        data: 0,
        isLoading: false,
        isError: false,
      },
      stateHistory: {
        data: [],
        pagination: {
          currentPage: 1,
          show: 10,
          perPage: 10,
          totalRows: 0,
          totalPages: 0,
          totalViewText: "",
          optionsLimit: CONSTANTS.OPTIONS_LIMIT_PAGINATION,
        },
        isLoading: false,
        isError: false,
      },
      stateTotalBalanceCabang: {
        data: null,
        isLoading: false,
        isError: false,
      },
      selectedCabang: null,
      isLoadingBulkInputKasVirtual: false,
      sortBy: 'amount',
      sortOrder: 'desc',
      isLoadingExportKasVirtual: false,
      filePathDownload: '',
    }
  },
  computed: {
    IS_HAVE_PERMISSION_INPUT_KAS_VIRTUAL() {
      return this.$helper.hasPermissionMenuChildren('KPV');
    },
    IS_ACTIVE_KAS_VIRTUAL() {
      return CONSTANTS.CABANG.STATUS_KAS_VIRTUAL.ACTIVE;
    },
  },
  methods: {
    async init() {
      this.initStatus = 0
      try {
        this.getCabang()
        this.getKasInduk()
        await this.getItems()
        this.initStatus = 1
      } catch (error) {
        this.$helper.parseError(this, error)
        this.initStatus = -1
      }
    },
    onSearch() {
      this.getItems();
    },
    onReset() {
      this.filters = {
        cabang: null,
      }

      this.getItems();
    },
    onSortChanged({ sortBy, sortDesc }) {
      if (!sortBy) return

      this.sortBy = sortBy
      this.sortOrder = sortDesc ? 'desc' : 'asc'
      this.getItems()
    },
    onSearchLogTransaksi() {
      this.getItemsLogTransaksi();
    },
    onResetLogTransaksi() {
      this.filters = {
        startDate: null,
        endDate: null,
      }

      this.getItemsLogTransaksi();
    },
    getItems(page = 1) {
      this.isBusy = true
      this.data = []
      this.currentPage = isNaN(page) ? 1 : page

      const params = {
        page: this.currentPage - 1,
        size: this.perPage,
      }

      if (!this.$helper.isNullOrEmpty(this.sortBy)) {
        params.sortCurrentVirtualBalance = this.sortOrder;
      }

      if (!this.$helper.isNullOrEmpty(this.filters.cabang)) {
        params.cabangId = this.filters.cabang.id;
      }

      return this.$axios.get("cabang/get-kas-virtual", {
        params,
      }).then(res => {

        this.data = res.data.content
        this.totalRows = res.data.totalElements

        let pg = this.currentPage - 1

        let prev = pg * this.show + 1
        let limit = pg * this.show + this.show
        if (limit > this.totalRows) limit = this.totalRows

        this.totalViewText = "Menampilkan " + prev + " - " + limit + " dari " + this.totalRows + " entri"
      }).catch(error => {
        this.$helper.parseError(this, error)
        throw error
      })
        .finally(() => {
          this.isBusy = false
        })
    },
    getItemsLogTransaksi(page = 1) {
      this.isBusyLogTransaksi = true
      this.dataLogTransaksi = []
      this.currentPageLogTransaksi = isNaN(page) ? 1 : page

      const params = {
        page: this.currentPageLogTransaksi - 1,
        size: this.perPageLogTransaksi,
      }

      if (!this.$helper.isNullOrEmpty(this.filters.startDate)) {
        params.startDate = this.filters.startDate;
      }

      if (!this.$helper.isNullOrEmpty(this.filters.endDate)) {
        params.endDate = this.filters.endDate;
      }

      return this.$axios.get("virtual-balance/finance-get-balance", {
        params,
      }).then(res => {

        this.dataLogTransaksi = res.data.content
        this.totalRowsLogTransaksi = res.data.totalElements

        let pg = this.currentPageLogTransaksi - 1

        let prev = pg * this.showLogTransaksi + 1
        let limit = pg * this.showLogTransaksi + this.showLogTransaksi
        if (limit > this.totalRowsLogTransaksi) limit = this.totalRowsLogTransaksi

        this.totalViewTextLogTransaksi = "Menampilkan " + prev + " - " + limit + " dari " + this.totalRowsLogTransaksi + " entri"
      }).catch(error => {
        this.$helper.parseError(this, error)
        throw error
      })
        .finally(() => {
          this.isBusyLogTransaksi = false
        })
    },
    onLimitChange(newPerPage) {
      this.perPage = newPerPage
      this.getItems()
    },
    onLimitChangeLogTransaksi(newPerPage) {
      this.perPageLogTransaksi = newPerPage
      this.getItemsLogTransaksi()
    },
    onPageChange(newPage) {
      this.getItems(newPage)
    },
    onPageChangeLogTransaksi(newPage) {
      this.getItemsLogTransaksi(newPage)
    },
    getCabang() {
      const getCabang = localStorage.getItem("cabang")
      const cabang = JSON.parse(getCabang);

      const mappingName = cabang.map(item => ({
        ...item,
        name: item.name.replace(/^\(\d+\)\s*/, "")
      }));

      this.optionsCabang = [
        { id: null, name: "Semua Cabang" },
        ...mappingName
      ]
    },
    onShowModalInputKasVirtual() {
      this.$bvModal.show('modal-input-kas-virtual')
    },
    handleResize() {
      this.isMobile = window.innerWidth <= 576;
    },
    onSuccessInputKasVirtual() {
      this.getItems()
      this.getKasInduk()
    },
    getKasInduk() {
      this.stateKasInduk.data = 0;
      this.stateKasInduk.isLoading = true;
      this.stateKasInduk.isError = false;
      this.$axios.get('virtual-balance/pgi/balance').then(response => {
        this.stateKasInduk.data = response.data.data.balance
      }).catch(error => {
        this.$helper.parseError(this, error)
        this.stateKasInduk.isError = true;
      }).finally(() => {
        this.stateKasInduk.isLoading = false;
      })
    },
    onShowLogTransaksi() {
      this.$bvModal.show('modal-log-transaksi')
      this.getItemsLogTransaksi();
    },
    onShowModalHistory(cabang) {
      this.selectedCabang = cabang
      this.$bvModal.show("modal-history-kas-virtual-action")
      this.getHistoryKasVirtual()
      this.getTotalBalanceCabang()
    },
    getHistoryKasVirtual(page) {
      this.stateHistory.data = [];
      this.stateHistory.isLoading = true;
      this.stateHistory.isError = false;
      this.stateHistory.pagination.currentPage = isNaN(page) ? 1 : page;

      const params = {
        cabangId: this.selectedCabang.id,
        page: this.stateHistory.pagination.currentPage - 1,
        size: this.stateHistory.pagination.perPage,
      }

      this.$axios.get('virtual-balance/finance-get-balance', { params }).then(response => {
        this.stateHistory.data = response.data.content;
        this.stateHistory.pagination.totalRows = response.data.totalElements

        let pg = this.stateHistory.pagination.currentPage - 1

        let prev = pg * this.stateHistory.pagination.show + 1
        let limit = pg * this.stateHistory.pagination.show + this.stateHistory.pagination.show
        if (limit > this.stateHistory.pagination.totalRows) limit = this.stateHistory.pagination.totalRows

        this.stateHistory.pagination.totalViewText = "Menampilkan " + prev + " - " + limit + " dari " + this.stateHistory.pagination.totalRows + " entri"
      }).catch(error => {
        this.$helper.parseError(this, error)
        this.stateHistory.isError = true;
      }).finally(() => {
        this.stateHistory.isLoading = false;
      })
    },
    getTotalBalanceCabang() {
      this.stateTotalBalanceCabang.data = null;
      this.stateTotalBalanceCabang.isLoading = true;
      this.stateTotalBalanceCabang.isError = false;
      const cabangId = this.selectedCabang.id
      this.$axios.get(`cabang/balance/${cabangId}`).then(response => {
        this.stateTotalBalanceCabang.data = response.data;
      }).catch(error => {
        this.$helper.parseError(this, error)
        this.stateTotalBalanceCabang.isError = true;
      }).finally(() => {
        this.stateTotalBalanceCabang.isLoading = false;
      })
    },
    onLimitChangeHistoryKas(newPerPage) {
      this.stateHistory.pagination.perPage = newPerPage
      this.getHistoryKasVirtual()
    },
    onPageChangeHistoryKas(newPage) {
      this.getHistoryKasVirtual(newPage)
    },
    onRetryHistoryKas() {
      this.getHistoryKasVirtual()
      this.getTotalBalanceCabang()
    },
    onShowModalBulkInputKasVirtual() {
      this.$bvModal.show('modal-bulk')
    },
    handleBulkInputKasVirtual(fileInput) {
      if (!fileInput) {
        this.$helper.toastErr(this, "Harap upload file terlebih dahulu.");
        return;
      }

      this.isLoadingBulkInputKasVirtual = true;

      const formData = new FormData();
      formData.append('file', fileInput);
      const headers = {
        'Content-Type': 'multipart/form-data'
      }

      this.$axios.post('virtual-balance/import-kas-virtual', formData, { headers })
        .then(response => {
          this.$helper.toastSucc(this, 'Import kas virtual berhasil')
          this.getItems()
          this.$bvModal.hide('modal-bulk');
        })
        .catch(error => {
          this.$helper.parseError(this, error);
        })
        .finally(() => {
          this.isLoadingBulkInputKasVirtual = false;
        });
    },
    onShowModalExportKasVirtual() {
      this.filePathDownload = '';
      this.$bvModal.show('modal-export-kas-virtual')
    },
    handleExportKasVirtual() {
      this.isLoadingExportKasVirtual = true;
      this.$axios.get("virtual-balance/export-kas-virtual").then(res => {
        this.filePathDownload = res.data.name
        this.$bvModal.hide('modal-export-kas-virtual')
        this.$bvModal.show('modal-download-kas-virtual')
      }).catch(error => {
        this.$helper.parseError(this, error)
      })
      .finally(() => {
        this.isLoadingExportKasVirtual = false;
      })
    }
  },
  created() {
    this.init();
  },
  mounted() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
}
</script>